import React, {useContext} from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"
import { Link as GatsbyLink } from "gatsby"

import { getLinkPropsFromReference } from '../../utils/link'
import { RichLinks, RichContent } from '../../utils/html'

import { getTheme } from '../../theme/theme'
import { margin, SIZE } from '../../theme/metrics'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'
import ResponsiveImage from '../responsive-image'

import { Container, Label, Heading, Text, Inner, TextContent, ImageContent, Image, Buttons } from './strip-cover.styles'


const StripCover = ({label,labelPath,heading,text,links,image,color}) => {
	const meta = useContext(PageMetaContext);

	let labelProps = {};
	if(labelPath){
		labelProps = {
			to: labelPath,
			as: GatsbyLink
		}
	}

	return (
		<ThemeProvider theme={(theme) => ({...theme,...getTheme(color)})}>
			<SectionContainer>
				<Inner squiggle={image == null}>
					<TextContent>
						{label && <Label {...labelProps}>{label}</Label>}
						{heading instanceof Array ? <Heading><RichContent render={heading} /></Heading> : <Heading><h1>{heading}</h1></Heading>}
						<Text><RichContent render={text} /></Text>
						<Buttons><RichLinks render={links} meta={meta} block="cover" /></Buttons>
					</TextContent>
					
					{image && 
						<ImageContent>
							<ResponsiveImage image={image} sizes={{medium:{span:5},large:{span:4}}} sizeOptions={{defaultSize:`calc(100vw - ${margin(SIZE.small,{multiplier:4})})`}} />
						</ImageContent>
					}
					
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default StripCover;